export * from "./cover-page.component";
